import _ from 'lodash';

/**
 * 작성한스케치 항목전체를 수정할수 있도록 저장하기 위해 인자를 graphql input type 에 맞게 변경해준다.
 * @param productItems graphql object items
 */
export const castSketchSaveArgs = productItems => {
  const result = productItems.map(x => {
    if (x.contents != null) {
      return {
        id: x.id,
        type: x.type,
        contents: x.contents,
        addStyle: x.addStyle
      };
    }
    return null;
  });

  return _.compact(result);
};

export const filterSpecialStyle = (styleStr, specialStyle) => {
  if (styleStr) {
    let filteredStyle;
    const arrStyles = styleStr.split(";");
    filteredStyle = _.chain(arrStyles)
      .remove((x: string) => {
        return x.indexOf(specialStyle);
      })
      .compact()
      .join(";")
      .value();

    return filteredStyle + ";";
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/util/helper.ts